
<spinner *ngIf="loading"></spinner>

<div class="d-flex justify-content-between">
    <p>
        <b>Jane Smith</b> &nbsp; Female, 24<br>
        12345678
    </p>
    <div class="buttons">

        <a>
            <i class="bi bi-gear-fill text-gray"></i>
        </a>
        <a>
            <i class="bi bi-bell-fill text-gray"></i>
        </a>

    </div>
</div>


<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-pills mt-3">
    <li [ngbNavItem]="1">
        <button ngbNavLink>Overview</button>
        <ng-template ngbNavContent>
            <ngb-alert [dismissible]="false" class="mt-3">
                <div class="row">
                    <div class="col">
                        <i class="bi bi-exclamation-triangle-fill" style="font-size:24px"></i> &nbsp;
                        <strong>Next video consultation &nbsp; 18/06/2025 10:30AM</strong> &nbsp;
                        <button class="btn btn-warning">DUE TODAY</button>
                    </div>
                    <div class="col-1 text-center">
                        Completed <br>
                        <input type="checkbox" class="form-check-input">
                    </div>
                    <div class="col-1 text-center">
                        Reschedule <br>
                        <i class="bi bi-calendar-week"></i>
                    </div>
                </div>
            </ngb-alert>
            <ngb-alert [dismissible]="false" [type]="'primary'">
                <div class="row">
                    <div class="col">
                        <i class="bi bi-camera-video-fill" style="font-size:24px"></i> &nbsp;
                        <strong>Next video consultation &nbsp; 18/06/2025 10:30AM</strong> &nbsp;
                        <button class="btn btn-primary">GO TO VIDEO CALL</button>
                    </div>
                    <div class="col-1 text-center">
                        Reschedule <br>
                        <i class="bi bi-calendar-week"></i>
                    </div>
                </div>
            </ngb-alert>
            <div class="row">
                <div class="col-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between">
                                <h5 class="fw-bold">Weight &gt;</h5>
                                <div>
                                    <i class="bi bi-caret-left-fill"></i> &nbsp;
                                    Week 2/6/2025 &nbsp;
                                    <i class="bi bi-caret-right-fill"></i>
                                </div>
                                <div></div>
                            </div>
                            <div style="height:400px">
                                <apx-chart
                                    [series]="weightChartOptions.series"
                                    [chart]="weightChartOptions.chart"
                                    [xaxis]="weightChartOptions.xaxis"
                                    [yaxis]="weightChartOptions.yaxis"
                                    [dataLabels]="weightChartOptions.dataLabels"
                                    [grid]="weightChartOptions.grid"
                                    [stroke]="weightChartOptions.stroke"
                                    [title]="weightChartOptions.title"
                                ></apx-chart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between">
                                <h5 class="fw-bold">ED-15 &gt;</h5>
                                <div>
                                    <i class="bi bi-caret-left-fill"></i> &nbsp;
                                    June 2025 &nbsp;
                                    <i class="bi bi-caret-right-fill"></i>
                                </div>
                                <div></div>
                            </div>
                            <div style="height:400px">
                                <apx-chart
                                    [series]="ed15ChartOptions.series"
                                    [chart]="ed15ChartOptions.chart"
                                    [xaxis]="ed15ChartOptions.xaxis"
                                    [yaxis]="ed15ChartOptions.yaxis"
                                    [dataLabels]="ed15ChartOptions.dataLabels"
                                    [grid]="ed15ChartOptions.grid"
                                    [stroke]="ed15ChartOptions.stroke"
                                    [title]="ed15ChartOptions.title"
                                ></apx-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="d-flex justify-content-between">
                        <h5 class="fw-bold">Latest daily snapshot &gt;</h5>
                        <div>
                            <i class="bi bi-caret-left-fill"></i> &nbsp;
                            Friday 11 May 2025 &nbsp;
                            <i class="bi bi-caret-right-fill"></i>
                        </div>
                        <div>
                            <i class="bi bi-calendar-week-fill px-1 text-gray"></i>
                            <small class="text-gray">Weekly view</small>
                        </div>
                    </div>

                    <ngx-datatable class="bootstrap" #table
                                   [rows]="latestDailySnapshotRows"
                                   [columnMode]="'force'"
                                   [headerHeight]="50"
                                   [footerHeight]="0"
                                   [rowHeight]="'auto'"
                    >
                        <ngx-datatable-column prop="participantName" name="" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.reported }}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="EXERCISE (MIN)" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="badge text-bg-danger">{{ row.exercise }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="PURGING BEHAVIOUR" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="badge text-bg-warning">{{ row.purgingBehaviour }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="USE OF LAXATIVES" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="badge text-bg-danger">{{ row.useOfLaxatives }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="USE OF DIURETICS" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="badge text-bg-success">{{ row.useOfDiuretics }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="BINGE EPISODES" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="badge text-bg-success">{{ row.bingeEpisodes }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="SKIPPED MEALS" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="badge text-bg-warning">{{ row.skippedMeals }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="LIFE EVENTS" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="badge text-bg-success">{{ row.lifeEvents }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-footer></ngx-datatable-footer>
                    </ngx-datatable>

                    <div class="d-flex justify-content-between mt-5">
                        <h5 class="fw-bold">Latest Routine Outcome Monitoring &gt;</h5>
                        <div>
                            <i class="bi bi-caret-left-fill"></i> &nbsp;
                            Friday 11 May 2025 &nbsp;
                            <i class="bi bi-caret-right-fill"></i>
                        </div>
                        <div>
                        </div>
                    </div>

                    <ngx-datatable class="bootstrap" #table
                                   [rows]="latestRoutineRows1"
                                   [columnMode]="'force'"
                                   [headerHeight]="50"
                                   [footerHeight]="0"
                                   [rowHeight]="'auto'"
                    >
                        <ngx-datatable-column prop="participantName" name="EDE-Q" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                80 Percentile &nbsp;
                                <i class="bi bi-arrow-up-right-square-fill" style="font-size: 18px"></i>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="ED-15" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                Symptom Severity: 4 &nbsp;
                                <i class="bi bi-arrow-down-right-square-fill" style="font-size: 18px"></i>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="PHQ-9" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                Moderately severe depression &nbsp;
                                <i class="bi bi-arrow-up-right-square-fill" style="font-size: 18px"></i>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="GAD-7" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                Moderate anxiety &nbsp;
                                <i class="bi bi-arrow-up-right-square-fill" style="font-size: 18px"></i>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-footer></ngx-datatable-footer>
                    </ngx-datatable>

                    <br>

                    <ngx-datatable class="bootstrap" #table
                                   [rows]="latestRoutineRows2"
                                   [columnMode]="'force'"
                                   [headerHeight]="50"
                                   [footerHeight]="0"
                                   [rowHeight]="'auto'"
                    >
                        <ngx-datatable-column prop="participantName" name="RCADS TOTAL" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                Clinical &nbsp;
                                <i class="bi bi-arrow-up-right-square-fill" style="font-size: 18px"></i>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="SEPARATION ANXIETY DISORDER" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                Borderline &nbsp;
                                <i class="bi bi-arrow-up-right-square-fill" style="font-size: 18px"></i>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="SOCIAL PHOBIA" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                Clinical &nbsp;
                                <i class="bi bi-arrow-up-right-square-fill" style="font-size: 18px"></i>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="GENERALISED ANXIETY DISORDER" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                Borderline &nbsp;
                                <i class="bi bi-arrow-up-right-square-fill" style="font-size: 18px"></i>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="PANIC DISORDER" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                Low &nbsp;
                                <i class="bi bi-arrow-up-right-square-fill" style="font-size: 18px"></i>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="OBSESSIVE-COMPULSIVE DISORDER" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                Clinical &nbsp;
                                <i class="bi bi-arrow-up-right-square-fill" style="font-size: 18px"></i>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="participantName" name="MAJOR DEPRESSIVE DISORDER" [sortable]="false" [flexGrow]="1">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                Clinical &nbsp;
                                <i class="bi bi-arrow-up-right-square-fill" style="font-size: 18px"></i>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-footer></ngx-datatable-footer>
                    </ngx-datatable>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <h5 class="fw-bold mb-3">
                        Personal Details &gt; &nbsp;
                        <a><i class="bi bi-pencil-square"></i></a>
                    </h5>

                    <div class="row mb-3">
                        <div class="col-3">
                            <p class="mb-2">
                                <b>Date of Birth</b> <br>
                                01/06/2000
                            </p>
                            <p class="mb-2">
                                <b>Telephone</b> <br>
                                +44 07777 777777
                            </p>
                            <p class="mb-2">
                                <b>Carer</b> <br>
                                Evelin Smith (Mother)
                            </p>
                            <p class="mb-2">
                                <b>Email</b> <br>
                                Evelyn.Smith&#64;email.com
                            </p>
                            <p class="mb-2">
                                <b>Patient Email</b> <br>
                                patient.Smith&#64;email.com
                            </p>
                        </div>
                        <div class="col-3">
                            <p class="mb-2">
                                <b>Medical Condition</b> <br>
                                Anorexia, ADHD, Autism
                            </p>
                            <p class="mb-2">
                                <b>Current Medication</b> <br>
                                &nbsp;
                            </p>
                            <p class="mb-2">
                                <b>Previous Medication</b> <br>
                                &nbsp;
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </li>

    <li [ngbNavItem]="3">
        <button ngbNavLink>Records</button>
        <ng-template ngbNavContent>
            <demo-patient-overview-records-tab></demo-patient-overview-records-tab>
        </ng-template>
    </li>
    <li [ngbNavItem]="4">
        <button ngbNavLink>Care Programme</button>
        <ng-template ngbNavContent>
            <cdss-create-therapeutic-schedule></cdss-create-therapeutic-schedule>
        </ng-template>
    </li>

</ul>

<div [ngbNavOutlet]="nav" class="mt-2"></div>
